import { render } from "./FileViewerDialog.vue?vue&type=template&id=f04aee9a&scoped=true&ts=true"
import script from "./FileViewerDialog.vue?vue&type=script&lang=ts"
export * from "./FileViewerDialog.vue?vue&type=script&lang=ts"

import "./FileViewerDialog.vue?vue&type=style&index=0&id=f04aee9a&lang=scss&scoped=true"
import "./FileViewerDialog.vue?vue&type=style&index=1&id=f04aee9a&lang=css"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04aee9a"]])

export default __exports__